<div class="screen-off" [class.screen-off-idle]="isIdle" [hidden]="!isScreenOff" (mousemove)="onActivity()"
  (touchstart)="onActivity()">
  <button type="button" class="screen-off-turn-on" (click)="turnScreenOn()">Turn Screen On</button>
</div>
